import { ListingService } from '../../../jobs-module/services/listing.service';
import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { Store } from '@ngrx/store';
import * as fromRoot from '../../../reducers';
import { Unit } from '../../models/unit';
import { CareerListing } from './career-page.model';

@Component({
  selector: 'mj-career-page',
  templateUrl: './career-page.component.html',
  styleUrls: ['./career-page.component.scss'],
})
export class CareerPageComponent implements OnInit, OnDestroy {
  public jobListingFormGroup: FormGroup;
  public listing: CareerListing;
  public unit: Unit;
  private unitSubscription: Subscription;

  constructor(
    private fb: FormBuilder,
    private listingService: ListingService,
    private ref: ChangeDetectorRef,
    private store: Store<fromRoot.State>
  ) {}

  ngOnInit(): void {
    document.body.scrollTop = 0;
    this.unitSubscription = this.store
      .select(fromRoot.getSelectedUnit)
      .subscribe(currentUnit => {
        if (currentUnit == null) {
          return;
        }
        this.unit = currentUnit;
        this.listingService.getCareerListing(this.unit.id).subscribe(
          storedListing => {
            this.listing = storedListing;
            // Todo this shouldn't be necessary
            this.ref.detectChanges();
          },
          error => {
            this.listing = CareerListing.createEmptyCareerListing(this.unit.id);
            this.ref.detectChanges();
          }
        );
      });
    this.jobListingFormGroup = this.fb.group({
      job_header_title: [null, Validators.required],
      job_description_description: [null, Validators.required],
      job_unit_description: [null, Validators.required],
    });
  }

  ngOnDestroy(): void {
    this.unitSubscription.unsubscribe();
  }
}
